export default "__VITE_ASSET__9542e9f9__"